import React, { FC } from 'react';
import Document from 'src/components/common/icons/Document';
import { IMRBeaconSVGProps } from './icons.types';

const CircleDocument: FC<IMRBeaconSVGProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
    >
      <circle cx="24" cy="24.5" r="23.5" stroke="black" />
      <foreignObject x="12" y="12" width="24" height="24">
        <div>
          <Document />
        </div>
      </foreignObject>
    </svg>
  );
};

export default CircleDocument;
